import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Language } from '../../../common/constants/language';
import { ToggleFullscreenMode, SetLanguage, SetFullscreenMode } from './app.actions';
import { AppState } from './app.state';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppFacade {
  currentLanguage$: Observable<Language> = this.store.select(AppState.getLanguage);
  fullscreenMode$: Observable<boolean> = this.store.select(AppState.getFullscreenMode);

  constructor(private store: Store) {}

  changeLang(lang: Language): void {
    this.store.dispatch(new SetLanguage(lang));
  }

  toggleFullscreenMode(): void {
    this.store.dispatch(new ToggleFullscreenMode());
  }

  setFullscreenMode(enabled: boolean): void {
    this.store.dispatch(new SetFullscreenMode(enabled));
  }
}
